import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslate } from 'react-admin';
import { Controller } from 'react-hook-form';

const useStyles = makeStyles({
  select: {
    backgroundColor: 'white!important',
    width: '180px',
    height: '48px!important',
    '& .MuiFilledInput-input:focus': {
      backgroundColor: 'rgba(255,255,255,0)',
    },
  },
});

export const SelectInput = ({
  name,
  control,
  label,
  options = [],
  sx = {},
  className = '',
  validation = {},
}) => {
  const translate = useTranslate();
  const classes = useStyles();

  const generateSingleOptions = () => {
    return options.map(option => (
      <MenuItem key={option?.id} value={option?.id}>
        {option?.name}
      </MenuItem>
    ));
  };

  return (
    <FormControl size="small">
      <Controller
        name={name}
        control={control}
        rules={validation} // Pasar las reglas de validación
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <InputLabel
              sx={
                error?.message ? { top: '10px', color: 'red' } : { top: '10px' }
              }
            >
              {label}
            </InputLabel>
            <Select
              onChange={onChange}
              value={value}
              size="medium"
              variant="filled"
              className={`${classes.select} ${className}`}
              error={!!error}
              sx={error?.message ? { ...sx, color: 'red' } : sx}
            >
              {generateSingleOptions()}
            </Select>
            {error?.message ? (
              <FormHelperText color="error" sx={{ color: 'red' }}>
                {translate(error?.message)}
              </FormHelperText>
            ) : null}
          </>
        )}
      />
    </FormControl>
  );
};
